import constants from '@/app-configs/constants'

export default [
  {
    path: '/settings',
    name: 'settings',
    component: () => import('@/views/settings/Settings.vue'),
    meta: {
      pageTitle: 'DEBTIA_SETTINGS',
      breadcrumb: [
        {
          text: 'DEBTIA_SETTINGS',
          active: true,
        },
      ],
      action: 'settings',
      resource: 'settings',
    },
  },
  {
    path: '/admin-settings',
    name: 'admin-settings',
    component: () => import('@/views/settings/CombinedAdminSettings.vue'),
    meta: {
      pageTitle: 'DEBTIA_ADMIN_SETTINGS',
      breadcrumb: [
        {
          text: 'DEBTIA_ADMIN_SETTINGS',
          active: true,
        },
      ],
      action: constants.action.permissionUserSettings,
      resource: constants.resource.user,
    },
  },
  {
    path: '/role-management',
    name: 'role-management',
    component: () => import('@/views/roles/Roles.vue'),
    meta: {
      pageTitle: 'DEBTIA_ROLE_MANAGEMENT',
      breadcrumb: [
        {
          text: 'DEBTIA_ROLE_MANAGEMENT',
          active: true,
        },
      ],
      action: constants.action.permissionRoleView,
      resource: constants.resource.role,
    },
  },
  {
    path: '/translations/:lang',
    name: 'translations',
    component: () => import('@/views/translations/list/Translations.vue'),
    meta: {
      pageTitle: 'DEBTIA_TRANSLATIONS',
      breadcrumb: [
        {
          text: 'DEBTIA_TRANSLATIONS',
          active: true,
        },
      ],
      navActiveLink: '',
      action: constants.action.permissionTranslationView,
      resource: constants.resource.translation,
    },
  },
  {
    path: '/rki-list',
    name: 'rki-normal-list',
    component: () => import('@/views/rkilisting/RkiListing.vue'),
    meta: {
      pageTitle: 'DEBTIA_TERMINATED_RKI_LIST',
      breadcrumb: [
        {
          text: 'DEBTIA_TERMINATED_RKI_LIST',
          active: true,
        },
      ],
      action: constants.action.permissionManualRkiRegistration,
      resource: constants.resource.user,
      companyOnly: true,
    },
  },
  {
    path: '/task-list',
    name: 'task-list',
    component: () => import('@/views/taskList/TaskList.vue'),
    meta: {
      pageTitle: 'DEBTIA_TASK_LIST',
      breadcrumb: [
        {
          text: 'DEBTIA_TASK_LIST',
          active: true,
        },
      ],
      action: 'company',
      resource: 'company',
      companyOnly: true,
    },
  },
  {
    path: '/filter-list',
    name: 'filter-list',
    component: () => import('@/views/filterList/FilterList.vue'),
    meta: {
      pageTitle: 'DEBTIA_FILTER_LIST',
      breadcrumb: [
        {
          text: 'DEBTIA_FILTER_LIST',
          active: true,
        },
      ],
      action: constants.action.permissionFilterListView,
      resource: constants.resource.filterLists,
      companyOnly: true,
    },
  },
  {
    path: '/add-filter-list',
    name: 'add-filter-list',
    component: () => import('@/views/filterList/CreateFilter.vue'),
    meta: {
      pageTitle: 'DEBTIA_ADD_FILTER',
      breadcrumb: [
        {
          text: 'DEBTIA_ADD_FILTER',
          active: true,
        },
      ],
      action: constants.action.permissionFilterListAdd,
      resource: constants.resource.filterLists,
      companyOnly: true,
    },
  },
  {
    path: '/view-filter-list/:id',
    name: 'view-filter-list',
    component: () => import('@/views/filterList/ViewFilter.vue'),
    meta: {
      pageTitle: 'DEBTIA_VIEW_FILTER_DETAILS',
      breadcrumb: [
        {
          text: 'DEBTIA_VIEW_FILTER_DETAILS',
          active: true,
        },
      ],
      action: constants.action.permissionFilterListEdit,
      resource: constants.resource.filterLists,
      companyOnly: true,
    },
  },
  {
    path: '/view-filter-details/:id',
    name: 'view-filter-details',
    component: () => import('@/views/filterList/FilterDetails.vue'),
    meta: {
      pageTitle: 'DEBTIA_VIEW_FILTER_LIST',
      breadcrumb: [
        {
          text: 'DEBTIA_VIEW_FILTER_LIST',
          active: true,
        },
      ],
      action: constants.action.permissionLogin,
      resource: constants.resource.user,
      companyOnly: true,
    },
  },
  {
    path: '/stuck-cases',
    name: 'stuck-cases',
    component: () => import('@/views/settings/StuckCases.vue'),
    meta: {
      pageTitle: 'DEBTIA_STUCK_CASES',
      breadcrumb: [
        {
          text: 'DEBTIA_STUCK_CASES',
          active: true,
        },
      ],
      action: constants.action.permissionStuckCases,
      resource: constants.resource.user,
    },
  },
]
